<template>
  <el-header id="header" style="text-align: right; font-size: 12px">
    <el-row type="flex">
      <el-col
        class="d-large-none"
        :xl="1"
        :lg="1"
        :md="1"
        :sm="1"
        :xs="2"
        v-if="windowSize < 1200"
      >
        <div @click="toggleSidebar" class="togglerButton mt-4">
          <span class="top-icon-bar" :class="{ openedMenu: isCollapse }"></span>
          <span
            class="middle-icon-bar"
            :class="{ openedMenu: isCollapse }"
          ></span>
          <span
            class="bottom-icon-bar"
            :class="{ openedMenu: isCollapse }"
          ></span>
        </div>
      </el-col>
      <el-col
        :class="windowSize > 1200 ? 'static-width' : ''"
        :xl="4"
        :lg="4"
        :md="3"
        :sm="2"
        :xs="2"
      >
        <div class="navbar-header">
          <router-link to="/dashboard" style="float: left">
            <!-- <img src="@/assets/echob2b_logo.svg" alt="logo" class="float-left logoStyle mt-3"> -->
            <!-- <img
              src="@/assets/gregorys_logo.png"
              alt="logo"
              class="float-left logoStyle"
            /> -->
            <img
              src="@/assets/images/logo1.png"
              alt="logo"
              class="float-left logoStyle1"
            />
            <img
              src="@/assets/images/logo2.png"
              alt="logo"
              class="float-left logoStyle2"
            />
            <img
              src="@/assets/images/logo3.png"
              alt="logo"
              class="float-left logoStyle3"
            />
          </router-link>
        </div>
      </el-col>
      <el-col
        :xl="20"
        :lg="20"
        :md="19"
        :sm="18"
        :xs="18"
        class="weg-button-location-container-outer"
      >
        <a href="https://learnonline.gr/login/index.php" target="_blank">
          <img
            src="@/assets/images/simple_book.svg"
            alt="library"
            height="30"
            width="30"
            style="margin: 18px 0 0;"
          />
        </a>
        <div
          class="storeAddress hidden-sm-and-down"
          v-if="displaySelectedLocationTitle"
        >
          <p>{{ displaySelectedLocationTitle }}</p>
        </div>
        <div v-if="showWegButton" class="weg-button-container">
          <a href="#" @click="wegRedirect">
            <img
              src="@/assets/images/weg.png"
              alt="weg"
              height="34.5"
              style="margin: 13px 0 13px 13px;"
            />
          </a>
        </div>
      </el-col>
      <el-col :xl="2" :lg="2" :md="2" :sm="4" :xs="4">
        <el-row class="mt-3" type="flex" :gutter="10">
          <el-col :xl="18" :lg="18" :md="14" :sm="14" :xs="12">
            <LangSelector :asDropDown="true"/>
          </el-col>
          <el-col :xl="6" :lg="6" :md="10" :sm="10" :xs="12">
            <el-dropdown trigger="click">
              <span v-if="UserData.avatar">
                <img
                  :src="path(UserData.id, UserData.avatar)"
                  alt="profile"
                  class="profilePic rounded"
                />
              </span>
              <span v-else class="UserAvatar pointer">{{
                  getLetters(UserData.f_name, UserData.l_name, UserData.company)
                }}</span>
              <el-dropdown-menu slot="dropdown">
                <p class="loggedAs pl-2">{{ $translation('Logged_in_as') }}</p>
                <p class="userName pl-2">{{ this.UserData.f_name }}</p>
                <p
                  v-if="
                    this.UserData.information && this.UserData.information.email
                  "
                  class="userEmail pl-2"
                >
                  {{ this.UserData.information.email }}
                </p>
                <p class="pointer pl-2" v-if="userRoleGetter != 'greg-user'">
                  <router-link to="/settings">
                    <svgicon
                      icon="profilesettings"
                      width="12"
                      height="12"
                      color="#2b2a29"
                      class="mr-2"
                    ></svgicon>
                    {{ $translation('Profile_Settings') }}
                  </router-link>
                </p>
                <p class="pointer pl-2 d-none">
                  <svgicon
                    icon="accountsettings"
                    width="12"
                    height="12"
                    color="#2b2a29"
                    class="mr-2"
                  ></svgicon
                  >
                  Account Settings
                </p>
                <div class="pl-2">
                  <el-select
                    v-if="FranchiseStoresGetter.length > 0"
                    v-model="selectedLocation"
                    :placeholder="$translation('b2b_select_store')"
                    @change="setLocation"
                  >
                    <el-option
                      v-for="store in FranchiseStoresGetter"
                      :key="store.id"
                      :label="store.title_cutted"
                      :value="store.id"
                    ></el-option>
                  </el-select>
                </div>
                <div v-if="UserData.id === 1">
                  <hr class="mt-4"/>
                  <p class="usePortal">
                    {{ $translation('Use_portal_in_as') }}
                  </p>
                  <!-- Select User submenu -->
                  <VuePerfectScrollbar class="userList">
                    <p
                      v-for="Employee in Employees.slice(
                        0,
                        this.EmployeesLimit
                      )"
                      :key="Employee.id"
                      class="pointer"
                    >
                      <span v-if="Employee.avatar">
                        <img
                          id="circleProfile"
                          :src="path(Employee.id, Employee.avatar)"
                          alt="av"
                        />
                      </span>
                      <span v-else class="circle">{{
                          getLetters(Employee.f_name, Employee.l_name)
                        }}</span>
                      {{ Employee.f_name + ' ' + Employee.l_name }}
                    </p>
                  </VuePerfectScrollbar>
                  <p
                    v-if="
                      this.EmployeesLimit === 4 && this.Employees.length > 4
                    "
                    class="text-center viewAllUsers pointer"
                    @click="viewAll"
                  >
                    {{ $translation('View_all_users') }}
                  </p>
                  <p
                    v-else-if="this.EmployeesLimit > 4"
                    class="text-center viewAllUsers pointer"
                    @click="viewLess"
                  >
                    {{ $translation('View_less_users') }}
                  </p>
                </div>
                <!-- <el-select  v-model="value" :placeholder="$t('route.SelectUser')" v-if="this.UserData.id === 716" @change="changeProfile(value)">
                        <el-option
                        v-if="showMaster()"
                        label="Master"
                        value="master">
                        </el-option>
                        <el-option
                          v-for="item in options"
                          :key="item.id"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                </el-select>-->
                <!-- end of select user submenu -->
                <hr class="ml-1 mr-1"/>
                <p class="pl-2 mt-2 mb-2 pointer" @click="logout">
                  <svgicon
                    icon="logout"
                    width="10"
                    height="10"
                    color="#2b2a29"
                    class="mr-2"
                  ></svgicon>
                  {{ $translation('Log_out') }}
                </p>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-header>
</template>
<script>
import {auth} from '@/SSO/config/auth.js';
import store from '@/store';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import LangSelector from '@/components/LangSelector/index.vue';
import '@/compiled-icons/';
import svgicon from 'vue-svgicon';
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
import {AUTH_LOGOUT} from '@/store/actions/auth';
import {
  getHeader,
  LogoutLogApi,
  refreshToken,
  wegUserAuth
} from '@/utils/echoApi';
import EventBus from '@/event-bus';

export default {
  name: 'Header',
  components: {
    svgicon,
    VuePerfectScrollbar,
    LangSelector
  },
  data() {
    return {
      // token: [{
      //   access_token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIzRWIweFVUYlVGY0pNMzJ4Vk9CUE9wIiwiaWF0IjoxNTMyNjA5Mjk4LCJleHAiOjE1MzI2MTI4OTgsInNjb3BlIjp7InR5cGUiOjMsImdyYW50X3R5cGUiOiJhY2Nlc3MiLCJjb250YWN0X2lkIjo1NDV9fQ.XjU3kqcmuJFwVQAgwrIfuVkGMLZDuPqNcYuKWbEGBpI',
      //   refresh_token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIyaVVMVVQ0ZTF2aXUxVVBpbmRRVXFmIiwiaWF0IjoxNTMyNjA5Mjk4LCJleHAiOjE1MzM4MTg4OTgsInNjb3BlIjp7ImdyYW50X3R5cGUiOiJyZWZyZXNoIiwiY29udGFjdF9pZCI6NTQ1fX0.Y3udqFKojdR6xDQFZqBoYlUAgQAwUnZS1QaQ199jreg'
      // }],
      options: [
        {
          id: '1',
          label: 'Jimmys',
          value: [
            {
              access_token:
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIyNzB0aEI3T2RudGNPQWpaZUxSRGt3IiwiaWF0IjoxNTMyNjIxNDUxLCJleHAiOjE1MzI2MjUwNTEsInNjb3BlIjp7InR5cGUiOjMsImdyYW50X3R5cGUiOiJhY2Nlc3MiLCJjb250YWN0X2lkIjo1NDV9fQ.sKhQl2FAMAD1Je30OvMHnZm74Vl37rdcBVikXBclfC8',
              refresh_token:
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIzVmFKVHhyc0tuZnN0bWpzQkRrWXplIiwiaWF0IjoxNTMyNjIxNDUxLCJleHAiOjE1MzM4MzEwNTEsInNjb3BlIjp7ImdyYW50X3R5cGUiOiJyZWZyZXNoIiwiY29udGFjdF9pZCI6NTQ1fX0.ql3dZV-mKQTpwbCiulfkCBlFLWkAbJa-lQUAhveGJyk'
            }
          ]
        },
        {
          value: 'Option2',
          label: 'Option2'
        },
        {
          value: 'Option3',
          label: 'Option3'
        },
        {
          value: 'Option4',
          label: 'Option4'
        },
        {
          value: 'Option5',
          label: 'Option5'
        }
      ],
      value: '',
      // baseStyles: {
      //   background: 'linear-gradient(#275deg, #104e7f, #03a8fc)'
      // },
      links: [],
      state2: '',
      EmployeesLimit: 4
    };
  },
  computed: {
    language() {
      return this.$store.getters.getMyLang;
    },
    ...mapGetters('data', ['FranchiseStoresGetter']),
    ...mapGetters('data', ['selectedLocationGetter']),
    ...mapGetters('data', ['selectedWarehouseGetter']),
    ...mapGetters('data', ['userRoleGetter']),
    ...mapGetters('data', ['loggedWithAzureGetter']),
    ...mapGetters('tickets', ['ticketsTabGetter']),
    ...mapState('data', {
      Employees: state => state.Employees
    }),
    ...mapState('menu', {
      isCollapse: state => state.openedMenu
    }),
    ...mapState('window', {
      windowSize: state => state.size
    }),
    ...mapState('data', {
      UserData: state => state.UserData
    }),
    ...mapState('data', {
      tokenData: state => state.tokenData
    }),
    ...mapState('data', {
      masterTokenData: state => state.masterTokenData
    }),
    ...mapState('data', {
      localpath: state => state.hostname
    }),
    ...mapGetters('data', ['WegGetter', 'userRoleGetter']),
    ...mapState('data', {
      UserType: state => state.UserData.type
    }),
    wegPortalAccess() {
      return this.WegGetter ? this.WegGetter.value : false;
    },
    showWegButton() {
      // return this.userRoleGetter === 'franchisee' && this.wegPortalAccess;
      return this.wegPortalAccess;
    },
    displaySelectedLocationTitle() {
      let store = this.FranchiseStoresGetter.find(location => {
        return location.id === this.selectedLocation;
      });
      return store && store.title_cutted ? store.title_cutted : '';
    },
    selectedLocation: {
      get() {
        return this.selectedLocationGetter;
      },
      set(value) {
        this.SET_SELECTED_LOCATION(value);
        this.updateSelectedLocationInfo(value);
      }
    },
    selectedWarehouse: {
      get() {
        return this.selectedWarehouseGetter;
      },
      set(value) {
        this.SET_SELECTED_WAREHOUSE(value);
      }
    }
  },
  mounted() {
    if (localStorage.getItem('currentLocation')) {
      this.selectedLocation = JSON.parse(
        localStorage.getItem('currentLocation')
      );
    }

    if (localStorage.getItem('currentWarehouse')) {
      this.selectedWarehouse = JSON.parse(
        localStorage.getItem('currentWarehouse')
      );
    }
    this.links = this.loadAll();
  },
  methods: {
    ...mapMutations('data', ['SET_SELECTED_LOCATION']),
    ...mapMutations('data', ['SET_SELECTED_WAREHOUSE']),
    ...mapMutations('data', ['SET_SELECTED_LOCATION_INFO']),
    ...mapMutations('date', ['SET_MICROSOFT_LOGIN']),
    ...mapActions('data', {
      getLicenses: 'getLicenses',
      getMaintenance: 'getMaintenance'
    }),
    ...mapActions('data', ['getAnnouncments']),
    ...mapActions('receipts', ['getReceipts']),
    ...mapActions('data', ['getStaff']),
    ...mapActions('data', ['getEvaluationReports']),
    ...mapActions('data', ['getCheckLists']),
    ...mapActions('data', ['getTasksData']),
    ...mapActions('data', ['getPosts']),
    ...mapActions('tickets', ['getTickets']),
    ...mapActions('ticketsV2', {getTicketsV2: 'getTickets'}),
    handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.$store.dispatch('setLanguage', lang);
      this.$store.dispatch('data/getMenus');
    },
    updateSelectedLocationInfo(selectedLocationId) {
      let selectedStore = this.FranchiseStoresGetter.find(store => {
        return store.id === selectedLocationId;
      });
      this.SET_SELECTED_LOCATION_INFO(selectedStore);
    },
    wegRedirect() {
      this.$http
        .get('https://' + this.localpath + wegUserAuth, {
          headers: getHeader()
        })
        .then(response => {
          console.log(response.data);

          window.open(response.data.url, '_blank');
        })
        .catch(error => {
          // handle error
          // console.log(error);
          if (error.response.status === 401) {
            refreshToken().then(resposne => {
              this.$http
                .get('https://' + this.localpath + wegUserAuth, {
                  headers: getHeader()
                })
                .then(response => {
                  window.open(response.data.url, '_blank');
                });
            });
          }
        });
    },
    setLocation(value) {
      localStorage.setItem('currentLocation', JSON.stringify(value));
      this.selectedLocation = value;

      let selectedStore = this.FranchiseStoresGetter.find(store => {
        return store.id === value;
      });

      localStorage.setItem(
        'currentWarehouse',
        JSON.stringify(selectedStore.warehouse_id)
      );
      this.SET_SELECTED_WAREHOUSE(selectedStore.warehouse_id);
      this.updateSelectedLocationInfo(this.selectedLocation);

      if (this.$route.name === 'users') {
        this.getStaff();
      } else if (this.$route.name === 'licenses') {
        this.getLicenses();
      } else if (this.$route.name === 'equipment-maintenance') {
        this.getMaintenance();
      } else if (this.$route.name === 'dashboard') {
        this.getStaff();
        this.getTasksData(this.selectedLocationGetter);

        // TODO check this, maybe it will change
        if (this.ticketsTabGetter === 'first') {
          this.getTickets({location: this.selectedLocationGetter});
        } else {
          this.getTickets({
            location: this.selectedLocationGetter,
            status: 'resolved'
          });
        }
        this.getAnnouncments(this.selectedLocationGetter);
        this.getLicenses();
        this.getMaintenance();
      } else if (
        this.$route.name === 'evaluations-report' ||
        this.$route.name === 'evaluations-report-specs'
      ) {
        this.getEvaluationReports(this.selectedLocationGetter);
      } else if (this.$route.name === 'checklists') {
        this.getCheckLists(this.selectedLocationGetter);
      } else if (this.$route.name === 'tasks') {
        this.getTasksData(this.selectedLocationGetter);
      } else if (this.$route.name === 'posts') {
        this.getPosts(this.selectedLocationGetter);
      } else if (this.$route.name === 'receipts') {
        this.getReceipts();
      } else if (this.$route.name === 'tickets') {
        // TODO this will change
        if (this.ticketsTabGetter === 'first') {
          this.getTickets({location: this.selectedLocationGetter});
        } else {
          this.getTickets({
            location: this.selectedLocationGetter,
            status: 'resolved'
          });
        }
      } else if (this.$route.name === 'tickets_v2') {
        // TODO this will change
        this.getTicketsV2({location: this.selectedLocationGetter});
        EventBus.$emit('resetTicketsFilters');
      }
    },
    showMaster() {
      return localStorage.getItem('authBUser');
    },
    changeProfile(data) {
      // console.log(id[0].access_token)
      // alert(this.masterTokenData[0].access_token)
      if (data === 'master') {
        store.state.data.tokenData = JSON.parse(
          atob(localStorage.getItem('authBUser'))
        );
        if (this.$router.history.current.path === '/dashboard') {
          store.dispatch('data/getCalendarDates');
          store.dispatch('data/getMeetingData');
          this.getAnnouncments(this.selectedLocationGetter);
        } else {
          this.$router.push('/dashboard');
        }
        localStorage.removeItem('authBUser');
      } else {
        if (!localStorage.getItem('authBUser')) {
          localStorage.setItem(
            'authBUser',
            btoa(JSON.stringify(this.tokenData))
          );
        }
        // alert(this.masterTokenData[0].access_token)
        store.state.data.tokenData = data[0];
        localStorage.setItem('authUser', btoa(JSON.stringify(data[0])));
        if (this.$router.history.current.path === '/dashboard') {
          store.dispatch('data/getCalendarDates');
          store.dispatch('data/getMeetingData');
          this.getAnnouncments(this.selectedLocationGetter);
        } else {
          this.$router.push('/dashboard');
        }
      }
    },
    querySearch(queryString, cb) {
      var links = this.links;
      var results = queryString
        ? links.filter(this.createFilter(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    logout: function () {
      let data = {};
      this.$http
        .post('https://' + this.localpath + LogoutLogApi, data, {
          headers: getHeader()
        })
        .then(response => {
          if (this.loggedWithAzureGetter) {
            this.$store.dispatch(AUTH_LOGOUT).then(() => {
              auth.logout();
              this.$router.push('/').catch(() => {
              });
            });
          } else {
            this.$store
              .dispatch(AUTH_LOGOUT)
              .then(() => this.$router.push('/').catch(() => {
              }));
          }
        })
        .catch(function (error) {
          // console.log(error);
          if (error.response.status === 401) {
            refreshToken().then(resposne => {
              this.$http
                .post('https://' + this.localpath + LogoutLogApi, data, {
                  headers: getHeader()
                })
                .then(response => {
                  if (response.status === 201) {
                    if (this.loggedWithAzureGetter) {
                      this.SET_MICROSOFT_LOGIN(false);
                      this.$store.dispatch(AUTH_LOGOUT).then(() => {
                        auth.logout();
                        this.$router.push('/').catch(() => {
                        });
                      });
                    } else {
                      this.$store
                        .dispatch(AUTH_LOGOUT)
                        .then(() => this.$router.push('/').catch(() => {
                        }));
                    }
                  }
                });
            });
          }
        });
      this.$router.push('/').catch(() => {
      });
    },
    // clear () {
    //   const input = this.$refs.searchInput
    //   alert(input.value)
    // },
    createFilter(queryString) {
      return link => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    loadAll() {
      return [
        {value: 'files'},
        {value: 'dashboard'},
        {value: 'subscriptions'},
        {value: 'Upcoming Meetings', link: '/dashboard'},
        {value: 'Meetings', link: '/dashboard'},
        {value: 'Upcoming', link: '/dashboard'},
        {value: 'vue-router', link: 'https://github.com/vuejs/vue-router'},
        {value: 'about us', link: 'https://github.com/babel/babel'}
      ];
    },
    handleSelect(item) {
      // console.log(item.link)
      if (item.link) {
        this.$router.push(item.link);
      } else {
        this.$router.push(item.value);
      }
    },
    toggleSidebar() {
      this.$store.state.menu.openedMenu = !this.$store.state.menu.openedMenu;
      if (this.$store.state.menu.openedMenu === true) {
        this.$store.state.menu.overlay = true;
      } else {
        this.$store.state.menu.overlay = false;
      }
    },
    viewAll() {
      this.EmployeesLimit = this.Employees.length;
    },
    viewLess() {
      this.EmployeesLimit = 4;
    },
    getLetters(Fname, Lname, company) {
      if (company) {
        let name = company.charAt(0) + company.charAt(1);
        return name;
      } else if (
        typeof Fname !== 'undefined' &&
        Fname &&
        typeof Lname !== 'undefined' &&
        Lname
      ) {
        var first = Fname.charAt(0);
        var second = Lname.charAt(0);
        return first + second;
      } else if (Fname || Lname) {
        var name = null;
        if (Fname) {
          name = Fname.charAt(0) + Fname.charAt(1);
        } else {
          name = Lname.charAt(0) + Lname.charAt(1);
        }

        return name;
      }
      //   alert(name.charAt(0))
    },
    path(id, avatar) {
      var exists =
        'https://' +
        this.localpath +
        '/echo/files/avatars/' +
        id +
        '.' +
        avatar;
      return exists;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/main.scss';
// .logoStyle {
//   width: 45%;
//   height: auto;
// }
.logoStyle1 {
  width: 24.24px;
  height: 30.11px;
  margin-top: 16px;
  // width: 45%;
  // height: auto;
}

.logoStyle2 {
  width: 13.23px;
  height: 17.79px;
  margin-top: 24.32px;
  // width: 45%;
  // height: auto;
}

.logoStyle3 {
  width: 35.3px;
  height: 33.78px;
  margin-top: 23.22px;
  // width: 45%;
  // height: auto;
}

.el-popper[x-placement^='bottom'] {
  width: 229px;
}

.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y {
  background-color: var(--main-color);
}

.storeAddress {
  color: #ffffff;
  font-size: 13px;
  display: flex;
  justify-content: center;
  margin-left: 10px;
  float: right;

  p {
    border: 1px solid #1e1e1e;
    border-radius: 6px;
    padding: 7px;
    //padding: 4px 15px;
    word-break: break-all;
    color: #1e1e1e;
    font-weight: 600;
  }
}

.userList {
  overflow-y: scroll;
  max-height: 500px;

  p {
    font-size: 12px;
    color: #454545;
    padding-bottom: 5px;
  }

  p:hover,
  p:focus {
    background-color: var(--main-color);
    opacity: 0.7;
    color: #ffffff;
    width: 222px;
  }
}

.pointer:hover,
.pointer:focus {
  background-color: var(--main-color);
  opacity: 0.7;
  color: #ffffff;
  width: 222px;

  a {
    color: #ffffff;
  }
}

#header {
  // background-image: linear-gradient(
  //   273deg,
  //   var(--secondary-color),
  //   var(--main-color)
  // );
  background-color: #d6d2c4;
  height: 65px;
  z-index: 1000;
  position: fixed;
  width: 100%;
  //  margin-bottom: 50px;
  .flags {
    height: 30px;
    width: 30px;
  }
}

.flagIcon {
  width: 20px;
  height: 20px;
  position: relative;
  top: 5px;
  right: 5px;
}

.loggedAs {
  font-size: 10px;
  font-style: italic;
  color: var(--main-color);
}

.usePortal {
  font-size: 10px;
  font-style: italic;
  color: var(--main-color);
  position: relative;
  // left: -13px;
}

.userName {
  font-size: 14px;
  color: #454545;
  margin-bottom: -10px !important;
}

.userEmail {
  font-size: 11px;
  color: #949494;
}

hr {
  height: 0.1px;
  opacity: 0.2;
  border: solid 1px #848483;
}

.viewAllUsers {
  font-size: 10px;
  font-style: italic;
  color: #454545;
  height: 20px;
  padding-top: 2px;
}

.navbar-brand {
  /*display: inline-block;*/
  img {
    border: 0;
    vertical-align: middle;
  }
}

.customSearchInput {
  width: 228px;
  height: 25px;

  input {
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    background-color: #ffffff45;
    border: transparent;
    color: #ffffff;
  }
}

.navbar-header {
  width: 255px;
  height: 100%;

  a {
    .navbar-brand {
      text-decoration: none;
      color: #fff;

      img {
        border: 0;
        vertical-align: middle;
      }
    }
  }
}

.togglerButton {
  cursor: pointer;
  background-color: transparent;
  border: transparent;

  &:hover {
    background-color: transparent;
  }
}

.search {
  font-size: 25px;
  color: #ffffff;
}

#circleProfile {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  background: var(--main-color);
  position: relative;
  top: 6px;
  margin-right: 5px;
}

.circle {
  border-radius: 50%;
  font-size: 10px;
  color: #fff;
  padding: 5px;
  line-height: 47px;
  text-align: center;
  background: var(--main-color);
  margin-right: 5px;
}

.UserAvatar {
  border-radius: 50%;
  font-size: 16px;
  color: #fff;
  padding: 5px;
  line-height: 30px;
  text-align: center;
  background: var(--main-color);
}

.el-select {
  width: 97%;
}

.weg-button-container {
  float: right;
}

.static-width {
  width: 255px;
}

@media only screen and (max-width: 991px) {
  .weg-button-location-container-outer {
    text-align: center;

    .weg-button-container {
      //float: none;
      margin: 0 auto;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue